import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { HelpCircle } from "lucide-react";

interface PaymentTermsHelperProps {
  onSelect: (terms: string) => void;
}

const PAYMENT_TERMS_EXAMPLES = [
  {
    category: "Full Payment",
    terms: [
      "In full in advance",
      "100% upfront",
      "Full payment due on booking",
      "Payment in full at confirmation",
    ],
  },
  {
    category: "Split Payments",
    terms: [
      "50% deposit, balance 30 days before departure",
      "30% deposit, 70% balance 60 days before departure",
      "20% to confirm, 80% 45 days before travel",
    ],
  },
  {
    category: "Installment Plans",
    terms: [
      "33% deposit, 33% in 30 days, 34% in 60 days",
      "25% quarterly over 4 quarters",
      "20% to confirm, 30% in July 2026, 50% in November 2026",
    ],
  },
  {
    category: "Deposit Options",
    terms: [
      "20% deposit, balance on arrival",
      "30% deposit to secure booking",
      "50% deposit, 50% 14 days before arrival",
    ],
  },
];

export function PaymentTermsHelper({ onSelect }: PaymentTermsHelperProps) {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-8 gap-2"
        >
          <HelpCircle className="h-4 w-4" />
          Terms
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent 
        align="end" 
        className="w-80 max-h-[400px] overflow-y-auto bg-background z-[300]"
      >
        <DropdownMenuLabel>Payment Terms Examples</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {PAYMENT_TERMS_EXAMPLES.map((group) => (
          <div key={group.category}>
            <DropdownMenuLabel className="text-xs font-semibold text-muted-foreground px-2 py-1.5">
              {group.category}
            </DropdownMenuLabel>
            {group.terms.map((term) => (
              <DropdownMenuItem
                key={term}
                onClick={() => onSelect(term)}
                className="cursor-pointer text-sm py-2"
              >
                {term}
              </DropdownMenuItem>
            ))}
            <DropdownMenuSeparator />
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
